import { IPortalNews } from './types';

export const convertNews = (data: IPortalNews<string>): IPortalNews<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
  date: data.date ? new Date(data.date) : undefined,
});
